<template>
  <div class="ApartmentManagement">
    <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList('search')">

      <el-form-item label="参数类型">
        <template>
          <el-select v-model="searchForm.param" placeholder="请选择">
            <el-option
              v-for="item in searchParamOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>

      <el-form-item label="内容">
        <el-input v-model="searchForm.val" placeholder="内容"></el-input>
      </el-form-item>

      <!-- <el-form-item label="所有者">
        <el-input v-model="searchForm.owner"
                  placeholder="所有者"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete" size="small" plain type="primary" @click="reset()">清空
        </el-button>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus" size="small" type="primary" @click="openModifyDialog()">添加Version
          </el-button>
        </el-col>
      </el-row>

    </el-form>
    <el-table class="dataTable" v-loading="dataListLoading" :data="dataList"
              :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border>

      <el-table-column label="升级任务类型">
        <template slot-scope="scope">
          <span v-if="scope.row.taskType == 1">产品型号</span>
          <span v-if="scope.row.taskType == 2">流水号</span>
          <span v-if="scope.row.taskType == 4">指定设备ID</span>
        </template>
      </el-table-column>
      <el-table-column label="类型数据">
        <template slot-scope="scope">
          <span v-if="scope.row.taskType == 1">(型号){{ scope.row.deviceModel }}</span>
          <span v-if="scope.row.taskType == 2">(流水号){{ scope.row.serialNumber }}</span>
          <span v-if="scope.row.taskType == 4">(设备ID){{ scope.row.mac }}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" prop="taskDesc" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="源版本号" prop="taskSrcVersion">
      </el-table-column>
      <el-table-column label="目标版本号" prop="taskDestVersion">
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime">
      </el-table-column>
      <el-table-column label="创建人" prop="createByUser">
      </el-table-column>
      <el-table-column label="通知优先级">
        <template slot-scope="scope">
          <span v-if="scope.row.notifyLevel == 1">低</span>
          <span v-if="scope.row.notifyLevel == 2">中</span>
          <span v-if="scope.row.notifyLevel == 3">高</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openDetailDialog(scope.row)">详情</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination :current-page="pageNo" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="totalPage"
                   background layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle">
    </el-pagination>

    <!-- 新增版本信息 -->
    <el-dialog :title="'添加Version'" :visible.sync="modifyDialog" width="40%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm" ref="modifyForm" :model="modifyForm" :rules="modifyRule" label-width="40%">

        <el-form-item label="版本描述" prop="versionDesc">
          <el-input style="width: 200px;" v-model="modifyForm.versionDesc" placeholder="请输入描述"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="型号" prop="deviceModel">
          <el-input style="width: 200px;" v-model="modifyForm.deviceModel" placeholder="请输入型号"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="源版本号" prop="mainVersion">
          <el-input style="width: 200px;" v-model="modifyForm.mainVersion" placeholder="请输入源版本号"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item>
          <span>Bin文件----</span>
        </el-form-item>
        <el-form-item label="binFile" prop="binFile">
          <input type="file" class="file" ref="upload"/>
        </el-form-item>

        <el-form-item label="binType" prop="binType">
          <template>
            <el-radio v-model="modifyForm.binType" label="front" border>front</el-radio>
            <el-radio v-model="modifyForm.binType" label="back" border>back</el-radio>
          </template>
        </el-form-item>

        <el-form-item label="binAddr" prop="binAddr">
          <el-input style="width: 200px;" v-model="modifyForm.binAddr" placeholder="请输入Addr"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="binSize" prop="binSize">
          <el-input style="width: 200px;" v-model="modifyForm.binSize" placeholder="请输入binSize" type="number"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="binVersion" prop="binVersion">
          <el-input style="width: 200px;" v-model="modifyForm.binVersion" placeholder="请输入binVersion"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="binPlatform" prop="binPlatform">
          <template>
            <el-radio v-model="modifyForm.binPlatform" label="FR" border>FR</el-radio>
            <el-radio v-model="modifyForm.binPlatform" label="BK" border>BK</el-radio>
            <el-radio v-model="modifyForm.binPlatform" label="CH" border>CH</el-radio>
          </template>
        </el-form-item>

        <el-form-item label="binChip" prop="binChip">
          <el-input style="width: 200px;" v-model="modifyForm.binChip" placeholder="请输入芯片型号"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="binDesc" prop="binDesc">
          <el-input style="width: 200px;" v-model="modifyForm.binDesc" placeholder="请输入bin描述"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary" @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 版本信息详情 -->
    <el-dialog title="任务详情" :visible.sync="detailDialog" width="40%" :before-close="cancelDetailDialog">
      <el-scrollbar style="height: 500px;">
        <el-form class="detailForm" ref="detailForm" :model="detailForm" label-width="40%">
          <el-form-item label="升级任务类型：" prop="taskType">
            <span v-if="detailForm.taskType == 1">产品型号</span>
            <span v-if="detailForm.taskType == 2">流水号</span>
            <span v-if="detailForm.taskType == 4">指定设备ID</span>
          </el-form-item>
          <el-form-item label="描述：" prop="taskDesc">
            <span>{{ detailForm.taskDesc }}</span>
          </el-form-item>
          <el-form-item label="型号：" prop="deviceModel">
            <span>{{ detailForm.deviceModel }}</span>
          </el-form-item>
          <el-form-item label="源版本号：" prop="taskSrcVersion">
            <span>{{ detailForm.taskSrcVersion }}</span>
          </el-form-item>
          <el-form-item label="目标版本号：" prop="taskDestVersion">
            <span>{{ detailForm.taskSrcVersion }}</span>
          </el-form-item>
          <el-form-item label="通知优先级：" prop="notifyLevel">
            <span v-if="detailForm.notifyLevel == 1">低优先级(常规)</span>
            <span v-if="detailForm.notifyLevel == 2">中优先级(询问跳转)</span>
            <span v-if="detailForm.notifyLevel == 3">高优先级(直接跳转)</span>
          </el-form-item>
          <el-form-item label="创建人：" prop="createByUser">
            <span>{{ detailForm.createByUser }}</span>
          </el-form-item>
          <el-form-item label="创建时间：" prop="createTime">
            <span>{{ detailForm.createTime }}</span>
          </el-form-item>
        </el-form>

        <el-form class="detailForm" ref="detailForm" v-for="(item,index) in detailForm.itemBeanList" :key="index"
                 label-width="40%">
          <el-form-item label="bin分割线：">
            <span>bin({{ index + 1 }})----------------------------------------</span>
          </el-form-item>
          <el-form-item label="bin文件：">
            <span>{{ item.binFileName }}</span>
          </el-form-item>
          <el-form-item label="binType：" prop="binType">
            <span>{{ item.binType }}</span>
          </el-form-item>
          <el-form-item label="binAddr：" prop="binAddr">
            <span>{{ item.binAddr }}</span>
          </el-form-item>
          <el-form-item label="binSize：" prop="binSize">
            <span>{{ item.binSize }}</span>
          </el-form-item>
          <el-form-item label="binVersion：" prop="binVersion">
            <span>{{ item.binVersion }}</span>
          </el-form-item>
          <el-form-item label="平台：" prop="binPlatform">
            <span>{{ item.binPlatform }}</span>
          </el-form-item>
          <el-form-item label="bin描述：" prop="binDesc">
            <span>{{ item.binDesc }}</span>
          </el-form-item>
          <el-form-item label="升级目标：" prop="taskDest">
            <span v-if="item.taskDest == 0">前板</span>
            <span v-if="item.taskDest == 1">后板</span>
            <span v-if="item.taskDest == 2">指纹</span>
          </el-form-item>
          <el-form-item label="升级方式：" prop="taskMode">
            <span v-if="item.taskMode == 1">App</span>
            <span v-if="item.taskMode == 2">Stack</span>
            <span v-if="item.taskMode == 3">全部</span>
          </el-form-item>
          <el-form-item label="升级模式：" prop="taskModel">
            <span v-if="item.taskModel == 0">后台(双分区)</span>
            <span v-if="item.taskModel == 1">前台(单分区)</span>
          </el-form-item>
          <el-form-item label="升级端口：" prop="taskPort">
            <span v-if="item.taskPort == 0">BLE</span>
            <span v-if="item.taskPort == 1">UART</span>
          </el-form-item>
          <el-form-item label="升级时APP连接的设备：" prop="taskMaster">
            <span v-if="item.taskNeedConnect == 0">串口升后板，蓝牙连前板</span>
            <span v-if="item.taskNeedConnect == 1">蓝牙升后板，蓝牙连后板</span>
            <span v-if="item.taskNeedConnect == 2">蓝牙升后板指纹，蓝牙连前板</span>
          </el-form-item>
          <el-form-item label="是否需要重新连接：" prop="taskMaster">
            <span v-if="item.taskMaster == 0">无需重连</span>
            <span v-if="item.taskMaster == 1">需要重连</span>
          </el-form-item>
          <el-form-item label="支持升级的分区：" prop="taskTargetPartition">
            <span>{{ item.taskTargetPartition }}</span>
          </el-form-item>
          <el-form-item label="升级顺序：" prop="taskSequence">
            <span>{{ item.taskSequence }}</span>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
      </el-scrollbar>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/ApartmentManagement.css'

export default {
  data() {
    return {
      userInfo: {},
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageNo: 1,
      pageSize: 10,
      totalPage: 1,
      modifyDialog: false,
      modifyForm: {},
      modifyRule: {
        versionDesc: [{
          required: true,
          message: '版本描述不能为空',
          trigger: 'blur'
        },],
        deviceModel: [{
          required: true,
          message: '型号不能为空',
          trigger: 'blur'
        },],
        mainVersion: [{
          required: true,
          message: '源版本号不能为空',
          trigger: 'blur'
        },],
        binFile: [{
          required: true,
          message: 'binFile不能为空',
          trigger: 'blur'
        },],
        binType: [{
          required: true,
          message: 'binType不能为空',
          trigger: 'blur'
        },],
        binAddr: [{
          required: true,
          message: 'binAddr不能为空',
          trigger: 'blur'
        },],
        binSize: [{
          required: true,
          message: 'binSize不能为空',
          trigger: 'blur'
        },],
        binVersion: [{
          required: true,
          message: 'binVersion不能为空',
          trigger: 'blur'
        },],
        binPlatform: [{
          required: true,
          message: 'binPlatform不能为空',
          trigger: 'blur'
        },],
        binDesc: [{
          required: true,
          message: 'binDesc不能为空',
          trigger: 'blur'
        },],
      },
      detailDialog: false,
      detailForm: {},
      taskRule: {
        taskDesc: [{
          required: true,
          message: '版本描述不能为空',
          trigger: 'blur'
        },],
        taskDestVersion: [{
          required: true,
          message: '型号不能为空',
          trigger: 'blur'
        },],
        taskSrcVersion: [{
          required: true,
          message: '源版本号不能为空',
          trigger: 'blur'
        },],
        profile: [{
          required: true,
          message: 'profile不能为空',
          trigger: 'blur'
        },],
        taskType: [{
          required: true,
          message: 'taskType不能为空',
          trigger: 'blur'
        },],
        deviceModel: [{
          required: true,
          message: 'deviceModel不能为空',
          trigger: 'blur'
        },],
        serialNumber: [{
          required: true,
          message: 'serialNumber不能为空',
          trigger: 'blur'
        },],
        mac: [{
          required: true,
          message: 'mac不能为空',
          trigger: 'blur'
        },],
        notifyLevel: [{
          required: true,
          message: 'notifyLevel不能为空',
          trigger: 'blur'
        },],
        taskDest: [{
          required: true,
          message: 'taskDest不能为空',
          trigger: 'blur'
        },],
        taskMode: [{
          required: true,
          message: 'taskMode不能为空',
          trigger: 'blur'
        },],
        taskModel: [{
          required: true,
          message: 'taskModel不能为空',
          trigger: 'blur'
        },],
        taskPort: [{
          required: true,
          message: 'taskPort不能为空',
          trigger: 'blur'
        },],
        taskMaster: [{
          required: true,
          message: 'taskMaster不能为空',
          trigger: 'blur'
        },],
        taskNeedConnect: [{
          required: true,
          message: 'taskNeedConnect不能为空',
          trigger: 'blur'
        },],
      },

      taskDialog: false,
      taskForm: {},
      taskTypeOption: [
        {
          value: '1',
          label: '产品型号升级'
        },
        {
          value: '2',
          label: '流水号升级'
        },
        {
          value: '4',
          label: '指定设备ID升级'
        }
      ],
      notifyLevelOption: [
        {
          value: '1',
          label: '低优先级(常规)'
        },
        {
          value: '2',
          label: '中优先级(询问跳转)'
        },
        {
          value: '3',
          label: '高优先级(直接跳转)'
        }
      ],


      taskMasterOption: [
        {
          value: '0',
          label: '串口升后板，蓝牙连前板'
        },
        {
          value: '1',
          label: '蓝牙升后板，蓝牙连后板'
        },
        {
          value: '2',
          label: '蓝牙升后板指纹，蓝牙连前板'
        }
      ],

      searchParamOption: [
        {
          value: 'no_select',
          label: '不选'
        },
        {
          value: 'mac',
          label: 'MAC地址'
        },
        {
          value: 'serialNumber',
          label: '流水号'
        },
        {
          value: 'taskSrcVersion',
          label: '任务源版本'
        },
        {
          value: 'taskDesc',
          label: '任务描述'
        }
      ],
    }
  },

  computed: {},

  created() {
    let self = this

    if (sessionStorage.getItem('userInfo')) {
      self.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }

    self.getDataList()
  },

  mounted() {
  },

  methods: {
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取数据列表
    getDataList(type) {
      let self = this

      let param = {}

      if (type == 'search') {
        self.pageNo = 1
        if (self.searchForm.param) {
          if (self.searchForm.param != 'no_select') {
            param[self.searchForm.param] = self.searchForm.val
          } else {
            self.searchForm.val = ''
          }
        }
      }

      param.pageNo = self.pageNo


      self.dataListLoading = true


      self.$axios
        ._getOtaTaskList(param)
        .then((res) => {
          self.dataListLoading = false
          const datas = res.data
          if (datas.code == 0) {
            if (datas.data && datas.data.dataPage && datas.data.dataPage.records) {
              let _dataList = datas.data.dataPage.records
              self.dataList = _dataList
            } else {
              self.$message.error('没有Task')
              self.dataList = []
            }

            self.totalPage = self.dataList.length
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.dataListLoading = false
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })


    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageNo = 1
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageNo = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (item) {
      let self = this
      // if (code) {
      //   self.$axios
      //     ._getApartmentInfo({
      //       apartmentCode: code,
      //     })
      //     .then((res) => {
      //       const datas = res.data
      //
      //       if (datas.code == 0) {
      //         self.modifyForm = datas.data
      //       } else {
      //         self.$message.closeAll()
      //         self.$message.error(datas.msg)
      //       }
      //     })
      //     .catch((error) => {
      //       self.$message.closeAll()
      //       self.$message.error('系统异常，请联系版本描述')
      //     })
      // }

      // self.modifyForm = this.deepCopy(item)

      self.modifyDialog = true
    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      let versionDesc = self.modifyForm.versionDesc
      let deviceModel = self.modifyForm.deviceModel
      let mainVersion = self.modifyForm.mainVersion

      let binType = self.modifyForm.binType
      let binAddr = self.modifyForm.binAddr
      let binSize = self.modifyForm.binSize
      let binVersion = self.modifyForm.binVersion
      let binPlatform = self.modifyForm.binPlatform
      let binChip = self.modifyForm.binChip
      let binDesc = self.modifyForm.binDesc

      if (!versionDesc || !deviceModel || !mainVersion || !binType ||
        !binAddr || !binSize || !binVersion || !binPlatform || !binDesc
      ) {
        this.$message.error('请输入有效升级参数')
        return
      }


      let myFile = this.$refs.upload
      let files = myFile.files
      if (files.length == 0) {
        this.$message.error('请选择文件')
        return
      }

      let file = files[0]
      if (file.name && !file.name.endsWith(".bin")) {
        this.$message.error('只能选择bin文件')
        return
      }

      let binObj = {
        binType: binType,
        binAddr: binAddr,
        binSize: binSize,
        binVersion: binVersion,
        binPlatform: binPlatform,
        binChip: binChip,
        binDesc: binDesc,
        binFile: file,
      }

      let binList = []
      binList.push(binObj)

      let param = new FormData()
      param.append('versionDesc', versionDesc)
      param.append('deviceModel', deviceModel)
      param.append('mainVersion', mainVersion)

      for (let i = 0; i < binList.length; i++) {
        for (let key in binObj) {
          param.append('binList[' + i + '].' + key, binObj[key])//参数拼接，形如:binList[0]
        }

      }

      self.$axios
        ._addVersion(param)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.cancelModifyDialog()
            self.getDataList('search')
            self.$message.success('添加成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常')
        })

    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      // Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      // self.$refs.modifyForm.resetFields()
      self.modifyDialog = false
    },

    addTask: function () {

      let self = this

      let versionId = self.taskForm.versionId
      let taskSrcVersion = self.taskForm.taskSrcVersion
      let taskDesc = self.taskForm.taskDesc
      let taskDestVersion = self.taskForm.taskDestVersion
      let profile = self.taskForm.profile
      let notifyLevel = self.taskForm.notifyLevel
      let taskType = self.taskForm.taskType


      let versionBinId = self.taskForm.versionBinId
      let taskDest = self.taskForm.taskDest
      let taskMode = self.taskForm.taskMode
      let taskModel = self.taskForm.taskModel
      let taskPort = self.taskForm.taskPort
      let taskMaster = self.taskForm.taskMaster
      let taskNeedConnect = self.taskForm.taskNeedConnect
      let taskTargetPartition = self.taskForm.taskTargetPartition
      let taskSequence = self.taskForm.taskSequence
      let binSrcVersion = self.taskForm.binSrcVersion

      if (!versionId || !taskSrcVersion || !taskDesc || !taskDestVersion ||
        !profile || !notifyLevel || !taskType || !versionBinId || !taskDest ||
        !taskMode || !taskModel || !taskPort || !taskMaster || !taskNeedConnect ||
        !taskTargetPartition || !taskSequence || !binSrcVersion
      ) {
        this.$message.error('请输入有效升级参数')
        return
      }

      let serialNumber = self.taskForm.serialNumber
      let mac = self.taskForm.mac
      let deviceModel = self.taskForm.deviceModel

      if ((taskType == 1 && !deviceModel) || (taskType == 2 && !serialNumber) || (taskType == 4 && !mac)) {
        this.$message.error('任务类型参数需完整')
        return
      }

      if (!confirm("确定提交吗？")) {
        return
      }

      let param = new FormData()
      param.append('versionId', versionId)
      param.append('taskSrcVersion', taskSrcVersion)
      param.append('taskDesc', taskDesc)
      param.append('taskDestVersion', taskDestVersion)
      param.append('profile', profile)
      param.append('notifyLevel', notifyLevel)
      param.append('taskType', taskType)

      if (taskType == 1) {
        param.append('deviceModel', deviceModel)
      } else if (taskType == 2) {
        param.append('serialNumber', serialNumber)
      } else if (taskType == 3) {
        param.append('mac', mac)
      }

      let binObj = {
        versionBinId: versionBinId,
        taskDest: taskDest,
        taskMode: taskMode,
        taskModel: taskModel,
        taskPort: taskPort,
        taskMaster: taskMaster,
        taskNeedConnect: taskNeedConnect,
        taskTargetPartition: taskTargetPartition,
        taskSequence: taskSequence,
        binSrcVersion: binSrcVersion,
      }

      let binList = []
      binList.push(binObj)

      for (let i = 0; i < binList.length; i++) {
        for (let key in binObj) {
          param.append('taskItemBeanList[' + i + '].' + key, binObj[key])//参数拼接，形如:binList[0]
        }

      }

    },

    openAddTaskDialog: function (item) {
      let self = this

      console.log("item:", item)

      let binUrl = item.binList[0].binUrl
      let urlArr = binUrl.split(/["\\\/"]/)
      self.taskForm.binFileName = urlArr[urlArr.length - 1]

      self.taskForm.versionDesc = item.versionDesc
      self.taskForm.mainVersion = item.mainVersion
      self.taskForm.versionId = item.versionId
      self.taskForm.versionBinId = item.versionBinId
      self.taskForm.taskTargetPartition = "*"
      self.taskForm.taskSequence = 0
      self.taskForm.binSrcVersion = "*"


      self.taskDialog = true
    },

    cancelAddTaskDialog: function () {
      let self = this
      self.taskForm = {}
      self.taskDialog = false
    },

    // 打开 版本信息弹窗
    openDetailDialog: function (item) {
      let self = this

      self.dataListLoading = true
      self.$axios
        ._getOtaTaskDetail({
          versionOtaTaskId: item.versionOtaTaskId,
        })
        .then((res) => {
          self.dataListLoading = false
          const datas = res.data

          if (datas.code == 0) {
            self.detailForm = datas.data


            let beanList = self.detailForm.itemBeanList
            if (beanList) {
              for (let i = 0; i < beanList.length; i++) {
                let binUrl = beanList[i].binUrl
                let urlArr = binUrl.split(/["\\\/"]/)
                beanList[i].binFileName = urlArr[urlArr.length - 1]
              }
            }

            self.detailDialog = true
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.dataListLoading = false
          self.$message.closeAll()
          self.$message.error('系统异常')
        })


    },

    // 关闭 版本信息弹窗
    cancelDetailDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除版本
    handleDelete(row) {
      let self = this

      self
        .$confirm(`是否确认要删除 "${row.taskDesc}" 版本`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delTask({versionOtaTaskId: row.versionOtaTaskId})
        })
        .then((data) => {
        })
    },

    delTask(param) {
      let self = this

      self.$axios
        ._delTask(param)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/OtaTaskManagement.vue